<script>
import Organization from "@/store/models/organization/organizationDTO";

export default {
    components: {},
    props: {
        title: {
            type: String,
            default: "",
        },
        entryRefrenceNo: {
            type: String,
            default: "",
        },
        organizationName: {
            type: String,
            default: "",
        },
        items: {
            type: Array,
            default: () => {
                return {};
            },
        },
        ctaButtons: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>
<template>
    <!-- start page title -->

    <div class="row">
        <div class="col-12">
            <div class="page-title-box">
                <div class="d-v-center d-flex-between">
                    <div class="d-v-center link-back flex-wrap">
                        <router-link v-for="cta in ctaButtons" v-bind:key="cta.text" tag="a" :to="{ name: cta.routeName }" class="chevron-border me-2 d-center">
                            <i class="bx bx-chevron-left list-back align-middle"></i>
                        </router-link>
                        <h4 class="me-1 mb-0">{{ title }}</h4>
                        <p class="mb-0 entry-title-batch" v-if="entryRefrenceNo != ''">{{ entryRefrenceNo }}</p>
                        <p class="mb-0 entry-title-batch" v-if="organizationName != ''">{{ organizationName }}</p>
                    </div>
                    <div class="">
                        <div class="qn-breadcrumb d-none d-md-block">
                            <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.entry-title-batch {
    border-radius: 22px;
    border: 1px solid rgba(84, 97, 102, 0.15);
    font-size: 14px;
    font-family: "poppins";
    font-weight: 500;
    color: #333f49;
    background-color: #fff;
    padding: 1px 8px;
}
</style>
